module.exports = __webpack_public_path__ + "static/img/image1_home.166bf42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/PC/image1_home.png
// module id = hkYE
// module chunks = 1